import { useState } from 'react'
import axios from 'axios'
import { Modal, message, Button, Spin } from 'antd'
import MyInput from '../../components/forms/input'
import MyRichText from '../../components/forms/richText'
import MyImageUpload from '../../components/forms/imageUpload'
import MyRadio from '../../components/forms/radio'
import MyTextArea from '../../components/forms/textArea'
import MyDocUpload from '../../components/forms/docUpload'
import MySwitch from '../../components/forms/switch'

const AddFitnessArticle = (props) => {
  const [formValue, setFormValue] = useState({})
  const [errorMsg, setErrorMsg] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  const handleSubmit = () => {
    setErrorMsg({})
    if (!formValue.title) {
      setErrorMsg({titleEmpty: '健身科普标题不能为空'})
      return false
    }

    axios.post('/admin/content/fitness_article/add', {
      title: formValue.title,
      cover_url: formValue.cover_url,
      mode: formValue.mode,
      rich_text: formValue.rich_text,
      page_link: formValue.page_link,
      doc_url: formValue.doc_url,
      is_top: formValue.is_top
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('创建成功！')
          props.getFitnessArticleData()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  const handleOk = () => {
    const isOk = handleSubmit()
    if (isOk !== false) {handleCancel()}
  }

  const handleNext = () => {
    handleSubmit()
    setFormValue({})
  }

  const handleCancel = () => {
    setErrorMsg({})
    setFormValue({})
    props.isCancel()
  }

  return (
    <Modal
      destroyOnClose={true}
      title="添加健身科普"
      width='800px'
      open={props.isOpen}
      onCancel={handleCancel}
      maskClosable={false}
      footer={[
        <Button key='cancel' onClick={handleCancel}>取消</Button>,
        <Button key='submit' onClick={handleNext}>提交并新建下一条</Button>,
        <Button key='isOk' type="primary" onClick={handleOk}>创建</Button>
      ]}>
      
      <Spin spinning={isLoading}>
        <MyInput
          id="title"
          required
          autoFocus
          maxLength={64}
          label='健身科普标题'
          placeholder='请输入健身科普标题'
          value={formValue.title}
          onChange={setFormValue}
          errorMsg={errorMsg.titleEmpty}
        />

        <MyImageUpload 
          id="cover_url"
          label='健身科普封面照片'
          value={formValue.cover_url}
          setValue={setFormValue}
        />

        <MyRadio
          id='mode'
          label='文章详情'
          options={[
            {
              label: '富文本',
              value: 1,
            },
            {
              label: '网页链接',
              value: 2,
            },
            {
              label: '文档',
              value: 3,
            }
          ]}
          defaultValue={1}
          value={formValue.mode}
          onChange={setFormValue}
        />

        {(!formValue.mode || formValue.mode === 1) && <MyRichText
          id='rich_text'
          value={formValue.rich_text}
          setValue={setFormValue}
        />}

        {formValue.mode === 2 && <MyTextArea 
          id="page_link"
          minRows={3}
          placeholder='请输入完整的网页链接地址'
          value={formValue.page_link}
          onChange={setFormValue}
        />}

        {formValue.mode === 3 && <MyDocUpload 
          id="doc_url"
          value={formValue.doc_url}
          setValue={setFormValue}
          setIsLoading={setIsLoading}
        />}

        <MySwitch 
          id='is_top'
          label='是否置顶'
          onChange={setFormValue}
        />
      </Spin>
    </Modal>
  )
}

export default AddFitnessArticle
